module.exports = __webpack_public_path__ + "static/media/product-available.b537e0bd.svg";